import { Link, useParams } from "react-router-dom";
import { Layout } from "../components/layout/Layout";
import { ArticleCard } from "../components/posts/ArticleCard";
import { JsonLd } from "../components/seo/JsonLd";
import { SEO } from "../components/seo/SEO";
import { collectionPageSchema, personSchema } from "../components/seo/schema";
import { getAuthor } from "../data/authors";
import { site } from "../data/site";
import { getPublishedPosts } from "../lib/posts";
import { NotFound } from "./NotFound";

export function AuthorPage() {
  const { slug = "" } = useParams();
  const author = getAuthor(slug);

  if (!author) return <NotFound />;

  const authorPosts = getPublishedPosts().filter((post) => post.author === author.slug);
  const canonical = `${site.url}/author/${author.slug}`;

  return (
    <Layout>
      <SEO title={`${author.name} - ${site.name}`} description={author.bio} canonical={canonical} />
      <JsonLd
        data={[
          personSchema(author),
          collectionPageSchema(
            `${author.name} Articles - ${site.name}`,
            author.bio,
            `/author/${author.slug}`,
            authorPosts.map((post) => post.url)
          )
        ]}
      />
      <header className="author-profile">
        <img src={author.avatar} alt="" width="112" height="112" />
        <div>
          <p className="eyebrow">{author.role}</p>
          <h1>{author.name}</h1>
          <p>{author.bio}</p>
          <div className="author-links">
            {author.socialLinks.map((link) => (
              <a key={link.url} href={link.url} rel="noreferrer" target="_blank">
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </header>
      <section className="section" aria-labelledby="author-articles">
        <div className="section-heading">
          <h2 id="author-articles">Articles by {author.name}</h2>
          <Link to="/search">Search all articles</Link>
        </div>
        <div className="article-list">
          {authorPosts.map((post) => (
            <ArticleCard key={post.slug} post={post} />
          ))}
        </div>
      </section>
    </Layout>
  );
}
